import React, { useState, useEffect } from "react";
import { Layout, Button, Drawer, Breadcrumb, theme } from "antd";
import LeftMenu from "./LeftMenu";
import RightMenu from "./RightMenu";
import { MenuOutlined, LoginOutlined, HomeOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import './Navigation.css';
import Config from '../../config/website.json';
import { useAuthStore } from "../../store/auth";
import { useAuth } from "../../hooks/AuthProvider";

const Navbar = ({ children }) => {

  const [visible, setVisible] = useState(false);
  const auth = useAuth();

  const handleLogin = () => {
    auth.loginAction();
  }

  const { isAuthenticated } = useAuthStore();
  const showDrawer = () => {
    setVisible(!visible);
  };

  let { pathname: location } = useLocation();
  useEffect(() => {
    setVisible(false);
  }, [location]);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  // Split the current path into its segments
  let segments = location.split('/').filter(Boolean);


  let crumbs = segments.map((segment, index) => {
    let link = `/${segments.slice(0, index + 1).join('/')}`;
    return {
      href: link,
      title: (
        <span>
          {segment.charAt(0).toUpperCase() + segment.slice(1)}
        </span>
      ),
    }
  })

  const crumbItems = [
    {
      href: '/',
      title: (
        <>
          <HomeOutlined />
          <span>Home</span>
        </>
      ),
    },
    ...crumbs
  ]

  return (
    <Layout style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: '5' }}>
      <div className="navbar">
        <Layout.Header className="nav-header" style={{ zIndex: '99999' }}>
          <div className="logo">
            <img alt={Config.website} src="/logo.png" width={80} />
          </div>
          <div className="navbar-menu">
            <div className="leftMenu">
              <LeftMenu mode={"horizontal"} />
            </div>
            <Button className="menuButton" type="text" onClick={showDrawer}>
              <MenuOutlined />
            </Button>
            <div className="rightMenu">
              {isAuthenticated ? (
                <RightMenu mode={"horizontal"} />
              ) : (
                <Button success type="primary" onClick={handleLogin} icon={<LoginOutlined />}>
                  Steam Login
                </Button>
              )}
            </div>

            <Drawer
              title={Config.website}
              placement="right"
              closable={true}
              onClose={showDrawer}
              open={visible}
              style={{ zIndex: 99999 }}
            >
              <LeftMenu mode={"inline"} />

              {isAuthenticated ? (
                <RightMenu mode={"inline"} />
              ) : (
                <Button type="primary" onClick={handleLogin} icon={<LoginOutlined />}>
                  Steam Login
                </Button>
              )}
            </Drawer>
          </div>
        </Layout.Header>
      </div>
      <Layout.Content style={{ width: '80%', padding: '0 48px', zIndex: '5' }}>
        <Breadcrumb
          items={crumbItems}
        />
        <div
          style={{
            width: "100%",
            backgroundColor: colorBgContainer,
            minHeight: 280,
            marginTop: 20,
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 15,
            paddingBottom: 15,
            borderRadius: borderRadiusLG,
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          }}
        >
          {children}
        </div>
      </Layout.Content>
      <Layout.Footer style={{ textAlign: "center" }}>
        {Config.website} ©2024 - Website created by {Config.author}
      </Layout.Footer>
    </Layout>
  );
};

export default Navbar;